export default __webpack_public_path__ + "static/media/almighty_card.df24cc8f.png";